import { FC, useEffect } from "react";
import Input from "shared/Input/Input";
import CommonLayout from "./CommonLayout";
import FormItem from "./FormItem";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentHolidayPackage, setHolidayPackage } from "application/features/holidayPackage/holidayPackageSlice";
import { useTranslation } from "react-i18next";
import CommonListingCardH from "components/CommonListingCardH/CommonListingCardH";
import { MemoContent } from "./HolidayPackageComposer";
import PriceSimulator from "components/Quasi/PriceSimulator/PriceSimulator";

export interface AddHolidayPackage8Props { }

const PageAddHolidayPackage8: FC<AddHolidayPackage8Props> = () => {

    const { t, ready } = useTranslation("translation");
    const holidayPackage = useSelector(selectCurrentHolidayPackage);
    const dispatch = useDispatch();

    const handleUpdateHolidayPackage = async (field: string, value: any) => {
        dispatch(setHolidayPackage({ ...holidayPackage, [field]: value }))
    };

    const _updateDefaultFields = async () => {
        dispatch(setHolidayPackage({
            ...holidayPackage,
            price: holidayPackage?.price ? holidayPackage.price : 0,
            package_content: holidayPackage?.package_content ? holidayPackage.package_content : {},
        }))
    }

    function preparedEvents(events: MemoContent[]) {
        const daysArray = Array.from({ length: holidayPackage?.duration_days || 1 }, (_, i) => i + 1);
        return daysArray.map(day => {
            const dayEvents = events.filter(event => event.day === day);
            return {
                day,
                events: dayEvents
            };
        });
    }


    function nextPageCondition() {
        return true
    }

    useEffect(() => {
        _updateDefaultFields();
        console.log("holidayPackage", holidayPackage);
        console.log("package_type:", holidayPackage?.package_type);
    }, []);

    if (!ready) return null;

    return (
        <CommonLayout
            index="08"
            backtHref={"/host/new-holiday-package/add-listing-7"}
            nextHref={"/host/new-holiday-package/add-listing-9"}
            canGoNext={nextPageCondition()}
            widePage={false}
        >
            <>
                {/* Confirmation Page */}
                <h2 className="text-2xl font-semibold">{t("translation:components.holidayPackageForm.page8.title")}</h2>
                <p className="text-sm text-neutral-500 dark:text-neutral-400">{t("translation:components.holidayPackageForm.page8.description")}</p>
                
                {/* Divider */}
                <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
                {/* SUMMARY */}
                <div className="space-y-8">
                    {/* ITEM */}
                    {
                        Object.keys(holidayPackage?.package_content).length > 0 && (
                            <div className="flex flex-col gap-4">
                                <div className="flex flex-col gap-4">
                                    {
                                        preparedEvents(holidayPackage?.package_content).map((item: { day: number, events: MemoContent[] }, index) => (
                                            <div key={`day-${item.day}`} className="flex flex-col gap-4">
                                                <h3 className="text-xl font-semibold">Day {item.day}</h3>
                                                <div className="flex flex-col gap-2">
                                                    <h4 className="font-semibold">{t("translation:components.holidayPackageForm.page8.accomodation")}</h4>
                                                    <div className="flex flex-col gap-2">
                                                        {
                                                            item.events && item.events.length > 0 && item.events.filter(event => event.type === "property").length > 0 ?
                                                                item.events.filter(event => event.type === "property").map((event: MemoContent, index: number) => (
                                                                    <div key={event.uuid || `property-${item.day}-${index}`} className="flex flex-row items-center justify-between p-2 rounded-md border-2 border-neutral-200 dark:border-neutral-700">
                                                                        <span>{event.title}</span>
                                                                        {/* <ButtonPrimary
                                                                        className="text-sm  !p-3 2xl:p-10 h-[3rem]"
                                                                        onClick={() => {}}
                                                                    >
                                                                        {t("translation:components.holidayPackageForm.page8.remove")}
                                                                    </ButtonPrimary> */}
                                                                    </div>
                                                                ))
                                                                :
                                                                <div className="text-red-500">{t("translation:components.holidayPackageForm.page8.noAccomodation")}</div>
                                                        }
                                                    </div>
                                                    <h4 className="font-semibold">{t("translation:components.holidayPackageForm.page8.experience")}</h4>
                                                    <div className="flex flex-col gap-2">
                                                        {
                                                            item.events && item.events.length > 0 && item.events.filter(event => event.type === "experience").length > 0 ?
                                                                item.events.filter(event => event.type === "experience").map((event: MemoContent, index: number) => (
                                                                    <div key={event.uuid || `experience-${item.day}-${index}`} className="flex flex-row items-center justify-between p-2 rounded-md border-2 border-neutral-200 dark:border-neutral-700">
                                                                        <span>{event.title}</span>
                                                                        {/* <ButtonPrimary
                                                                        className="text-sm  !p-3 2xl:p-10 h-[3rem]"
                                                                        onClick={() => {}}
                                                                    >
                                                                        {t("translation:components.holidayPackageForm.page8.remove")}
                                                                    </ButtonPrimary> */}
                                                                    </div>
                                                                ))
                                                                :
                                                                <div className="text-red-500">{t("translation:components.holidayPackageForm.page8.noExperience")}</div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        )
                    }
                </div>
                {/* FORM */}
                <div className="flex flex-col gap-4 mt-8">
                    <h3 className="text-xl font-semibold">{t("translation:components.holidayPackageForm.page8.pricing")}</h3>
                    <div className="flex flex-col gap-4">
                        <FormItem
                            label={(() => {
                                const labelText = holidayPackage?.package_type === "defined_guests"
                                    ? "Inserisci il prezzo del pacchetto"
                                    : "Inserisci il prezzo a persona";
                                console.log("Label text:", labelText);
                                console.log("Package type:", holidayPackage?.package_type);
                                return labelText;
                            })()}
                        >
                            <div className="flex gap-4 items-center justify-center max-w-2xl mx-auto">
                                <div className="flex-1">
                                    <Input
                                        type="number"
                                        value={holidayPackage?.price || 0}
                                        min={0}
                                        step={1}
                                        onChange={(e) => handleUpdateHolidayPackage("price", e.target.value)}
                                    />
                                </div>
                                <PriceSimulator basePrice={holidayPackage?.price || 0} />
                            </div>
                        </FormItem>
                    </div>
                </div>
                <div className="flex flex-col gap-4 mt-8">
                    <h3 className="text-xl font-semibold">{t("translation:components.holidayPackageForm.page8.preview")}</h3>
                    <p className="text-sm text-neutral-500 dark:text-neutral-400">{t("translation:components.holidayPackageForm.page8.previewDescription")}</p>
                    <div className="flex flex-col mt-4">
                        <CommonListingCardH
                            name={holidayPackage?.name || ""}
                            price={holidayPackage?.price || 0}
                            description={holidayPackage?.description || ""}
                            rating={holidayPackage?.rating || 0}
                            reviews_count={holidayPackage?.reviews_count || 0}
                            max_guests={holidayPackage?.package_type === "defined_guests" ? (holidayPackage?.defined_guests || 0) : (holidayPackage?.max_guests || 0)}
                            author={{
                                displayName: holidayPackage?.author?.displayName || "",
                                avatar: holidayPackage?.author?.avatar || ""
                            }}
                            cover={holidayPackage?.cover_image || ""}
                            gallery_images={holidayPackage?.gallery_images || []}
                            href="#"
                            showAuthor={false}
                            isLiked={false}
                            showButtons={false}
                            priceType={holidayPackage?.package_type === "defined_guests" ? "package" : "person"}
                        />
                    </div>
                </div>
            </>
        </CommonLayout >
    );
};

export default PageAddHolidayPackage8;
